import * as Yup from "yup";

const schema = Yup.object().shape({
  customerFirstName: Yup.string()
    .min(2, "First Name must be at least 2 characters")
    .max(20, "First Name must be 20 characters or less")
    .matches(/^[a-zA-Z0-9-'\s]+$/, {
      message:
        "First name must contain only alphanumeric characters and allowed special characters (-, ', and space)",
      excludeEmptyString: true,
    })
    .trim()
    .required("Please provide a first Name."),
  customerLastName: Yup.string()
    .min(2, "Last Name must be at least 2 characters")
    .max(20, "Last Name must be 20 characters or less")
    .matches(/^[a-zA-Z0-9-'\s]+$/, {
      message:
        "Last name must contain only alphanumeric characters and allowed special characters (-, ', and space)",
      excludeEmptyString: true,
    })
    .trim()
    .required("Please provide a last Name."),
  phoneNumber: Yup.string()
    .min(10, "Must be a valid phone number")
    .max(13, "Must be a valid phone number")
    .matches(/^(?!0+$)(\+44\s?|0)\d{3,4}[-\s]?\d{3}[-\s]?\d{4,6}$/, {
      message: "Must be a valid phone number",
      excludeEmptyString: true,
    })
    .required("Please provide a Phone Number"),
  reference: Yup.string(),
  emailAddress: Yup.string()
    .email("Please provide a valid Email address.")
    .matches(
      /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
      {
        message: "Please provide a valid Email address.",
        excludeEmptyString: true,
      }
    )
    .required("Please provide a valid Email address."),
  customerConsent: Yup.boolean()
    .oneOf([true], "Customer must consent to being contacted")
    .required("Customer consent is required"),
  notes: Yup.string().optional().max(500, "Notes must be 500 characters or less"),
});

export default schema;
